import ProjectNewsService from "@services/project-news-service";
import { useMutation, useQueryClient } from "react-query";
import { projectNewsQueryKeys } from "./queryKeys";

export const useUpdateProjectNewsMutation = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({ id, data }: { id: string; data: FormData }) => {
      return new Promise((resolve, reject) => {
        ProjectNewsService.update(id, data, (err, res) => {
          if (err || !res) {
            return reject(err);
          }
          resolve(res.data);
        });
      });
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(projectNewsQueryKeys.all);
      },
    }
  );
};
